import { DataPanelAutoWrapInlineItem } from '@/ui';
import type { Caller } from '@/signalr';
import { DateFormatter } from '@/features/shared/DateFormatter';

type GoogleElsSourceData = NonNullable<Caller['dataSources']['googleEls'][number]['data']>;

export type GoogleElsDiagnosticsPanelItemsProps = {
  data: GoogleElsSourceData;
};

export function GoogleElsDiagnosticsPanelItems({ data }: GoogleElsDiagnosticsPanelItemsProps) {
  const network = [data.device?.homeMcc, data.device?.homeMnc, data.device?.networkMcc, data.device?.networkMnc]
    .filter((part): part is string => part != null && part !== '')
    .join(' / ');

  return (
    <>
      <DataPanelAutoWrapInlineItem title="Activation source" value={data.activationSource} />
      <DataPanelAutoWrapInlineItem title="Dialled number" value={data.dialledNumber ?? undefined} showEmptyPlaceholder />

      <DataPanelAutoWrapInlineItem title="Session started">
        {data.sessionStartedAtUtc == null ? '–' : <DateFormatter date={data.sessionStartedAtUtc} formatType="calendar" />}
      </DataPanelAutoWrapInlineItem>
      <DataPanelAutoWrapInlineItem title="First received">
        <DateFormatter date={data.firstReceivedAtUtc} formatType="calendar" />
      </DataPanelAutoWrapInlineItem>
      <DataPanelAutoWrapInlineItem
        title="Protocol / Google ELS module version"
        value={[data.protocolVersion, data.googleElsModuleVersion]
          .filter((part): part is number => part != null)
          .join(' / ')}
        showEmptyPlaceholder
      />
      <DataPanelAutoWrapInlineItem title="Device model" value={data.device?.model ?? undefined} showEmptyPlaceholder />
      <DataPanelAutoWrapInlineItem title="Home / network MCC-MNC" value={network} showEmptyPlaceholder />
      <DataPanelAutoWrapInlineItem
        title="Medic data updated"
        value={data.medicData?.lastUpdatedAtUtc ?? undefined}
        showEmptyPlaceholder
      />
      <DataPanelAutoWrapInlineItem
        title="Anomalies"
        value={
          data.anomalies.length === 0
            ? undefined
            : data.anomalies.map((anomaly) => `${anomaly.field} (${anomaly.kind})`).join(', ')
        }
        showEmptyPlaceholder
      />
    </>
  );
}
